import { render, staticRenderFns } from "./FilterArea.vue?vue&type=template&id=551413cb"
import script from "./FilterArea.vue?vue&type=script&lang=js"
export * from "./FilterArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports